import type { DocumentsFromBackend } from './types';

import type { ServiceConfig } from '../../utils/create-http-api-service';
import { STRAPI_URL } from '../constants';
import { getStrapiQueryParams } from '../utils/query-params';
import { strapiServiceAdapter } from '../utils/strapi-service-adapter';
import { transformDocuments } from './transform';

// ---

const getDocuments = (
  documentURL: string,
  { brandName, language, instance, region }: ServiceConfig,
  filtersValue?: string,
) => {
  type AdapterProps = { response: DocumentsFromBackend };

  const queryParams = getStrapiQueryParams({ brandName, language, region });
  if (filtersValue) {
    queryParams.set('filters[slug][$eqi]', filtersValue);
  }
  const url = `${documentURL}?&${queryParams}`;

  return strapiServiceAdapter<AdapterProps, ReturnType<typeof transformDocuments>>(
    url,
    instance.get,
    { responseHandler: transformDocuments },
  );
};

export const getPrivacyPolicy = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'privacyPolicy');
};

export const getAMLManual = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'amlManual');
};

export const getGeneralTerms = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'generalTerms');
};

export const getResponsibleGaming = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'responsibleGaming');
};

export const getTermsOfService = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'termsOfService');
};

export const getAboutCompany = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'aboutCompany');
};

export const getOffer = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'contract-offer');
};

export const getCashbackRules = (config: ServiceConfig) => {
  return getDocuments(STRAPI_URL.DOCUMENTS, config, 'cashback');
};

export const getPromotion = (config: ServiceConfig, id:string) => {
  const url = `${STRAPI_URL.DOCUMENTS}/${id}/`;
  return getDocuments(url, config);
};
